import { render } from "./TransformList.vue?vue&type=template&id=6dcc04ae"
import script from "./TransformList.vue?vue&type=script&lang=js"
export * from "./TransformList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__